var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"game-info-navbar",class:{ isPad: _vm.$padFalg != 'other' }},[_c('div',{staticClass:"game-info-navbar-box"},[_c('div',{staticClass:"left-arrow",on:{"click":function($event){return _vm.callBack()}}}),(_vm.useTitle)?_c('div',{staticClass:"box-title"},[_vm._v(_vm._s(_vm.title))]):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }